/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetTunneledMcpServerRequest,
  GetTunneledMcpServerSecurity,
} from "../models/operations/gettunneledmcpserver.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildGetTunneledMcpServerQuery,
  GetTunneledMcpServerQueryData,
  prefetchGetTunneledMcpServer,
  queryKeyGetTunneledMcpServer,
} from "./getTunneledMcpServer.core.js";
export {
  buildGetTunneledMcpServerQuery,
  type GetTunneledMcpServerQueryData,
  prefetchGetTunneledMcpServer,
  queryKeyGetTunneledMcpServer,
};

export type GetTunneledMcpServerQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getServer tunneledMcp
 *
 * @remarks
 * Get a tunneled MCP server by ID
 */
export function useGetTunneledMcpServer(
  request: GetTunneledMcpServerRequest,
  security?: GetTunneledMcpServerSecurity | undefined,
  options?: QueryHookOptions<
    GetTunneledMcpServerQueryData,
    GetTunneledMcpServerQueryError
  >,
): UseQueryResult<
  GetTunneledMcpServerQueryData,
  GetTunneledMcpServerQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildGetTunneledMcpServerQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getServer tunneledMcp
 *
 * @remarks
 * Get a tunneled MCP server by ID
 */
export function useGetTunneledMcpServerSuspense(
  request: GetTunneledMcpServerRequest,
  security?: GetTunneledMcpServerSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    GetTunneledMcpServerQueryData,
    GetTunneledMcpServerQueryError
  >,
): UseSuspenseQueryResult<
  GetTunneledMcpServerQueryData,
  GetTunneledMcpServerQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildGetTunneledMcpServerQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setGetTunneledMcpServerData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      id: string;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: GetTunneledMcpServerQueryData,
): GetTunneledMcpServerQueryData | undefined {
  const key = queryKeyGetTunneledMcpServer(...queryKeyBase);

  return client.setQueryData<GetTunneledMcpServerQueryData>(key, data);
}

export function invalidateGetTunneledMcpServer(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      id: string;
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "tunneledMcp", "getServer", ...queryKeyBase],
  });
}

export function invalidateAllGetTunneledMcpServer(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "tunneledMcp", "getServer"],
  });
}
